// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { CapacityPlanningAreaId } from './CapacityPlanningAreaId'
import { CapacityPlanningAreaNavigation } from './CapacityPlanningAreaNavigation'
import { CapacityPlanningAreaRoutes } from './CapacityPlanningAreaRoutes'

const LazyCapacityPlanningComponent = lazy(
  () => import('./CapacityPlanningArea'),
)

const CapacityPlanningComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyCapacityPlanningComponent />
  </SuspenseLoadingWrapper>
)

export const CapacityPlanningArea = {
  id: CapacityPlanningAreaId,
  requiredRight: BoumRight.AREA_CAPACITY_PLANNING,
  NavigationComponent: CapacityPlanningAreaNavigation,
  route: {
    path: CapacityPlanningAreaRoutes.route,
    component: CapacityPlanningComponent,
  },
}
